<template>
  <aside id="nav-left_blank">
    <div class="nav-left-logo" />
    <div class="navList-spacer"></div>
    <div class="navList-title">PROFILE</div>
    <div class="navList-username">{{this.username}}</div>
    <div id="navList-wrapper">
      <div id="navList-container">
        <ul class="navList__left">
          <li class="navList__left__item">
            <div
              class="navList__left__subheading"
              v-on:click="logout()"
            >
              <span class="navList__left__subheading-icon navList__left__subheading-icon--logout"/>
              <span class="navList__left__subheading-title" >
                Logout
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'nav-left-blank',
  data() {
  return {
    username: this.$store.state.user,
  };
  },
  methods: {
    logout() {
      this.$router.replace('/logout');
    },
  },
};
</script>

<style>

#nav-left_blank {
  position: absolute;
  top: 0;
  left: 0;
  padding: 51px 12px;
  height: 100%;
  width: 248px;
  background-color: #fff;
  color: #222;
  z-index: 1;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0.2px 0 20px 0px #ccc;
}

.navList-spacer {
  padding-top: 30px;
}

.navList__left__subheading-icon {
  display: inline-block;
  position: absolute;
  top: 8px;
  height: 13px;
  width: 15px;
  background-image: url('~@/assets/icon/icon-12-exit-purple.svg');
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  transition: all .3s ease;
}

.navList__left__subheading:hover .navList__left__subheading-icon{
  background-image: url('~@/assets/icon/icon-12-megaphone-maroon.svg');
}

.navList__left__subheading:hover .navList__left__subheading-icon--logout{
  background-image: url('~@/assets/icon/icon-12-exit-maroon.svg');
}

.navList__left__subheading:hover .navList__left__subheading-title{
  color: #900C3E;
}

</style>
